import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { SurveyAnswerDetailDto } from "../bo/survey/survey-answer-detail";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };


@Injectable({
  providedIn: 'root'
})
export class SurveyService {
constructor(private readonly http:HttpClient) { }
    getSurveyQuestionsJsonData(regionId: number): Promise<any>{
        return this.http.get(environment.exploreURL + '/Regions/' + regionId + '/survey-form', httpOptions).toPromise();
    }

    getSurveyResponsesFromApi(blastId: number): Promise<any>{
        return this.http.get<string>(environment.exploreURL + `/Blasts/${blastId}/survey-answers`).toPromise();
     }

    saveSurveyResponsesFromApi(blastId: number, surveyAnswers: SurveyAnswerDetailDto[],regionId: number, userType: string){
        return this.http.post(environment.exploreURL + `/Blasts/${regionId}/survey-answers/${blastId}/${userType}`, surveyAnswers);
    }

    getSurveyAnswersBySite(
        siteId: number,
        beginDate?: Date,
        endDate?: Date
      ) {
        let params = new HttpParams();

        if (beginDate) {
          params = params.set('beginDate', beginDate.toISOString());
        }

        if (endDate) {
          params = params.set('endDate', endDate.toISOString());
        }

        return this.http
          .get<any>(`${environment.exploreURL}/Sites/${siteId}/survey-answers`, { params });
    }
}